document.addEventListener('DOMContentLoaded', function() {
  // Select all quantity buttons
  const plusButtons = document.querySelectorAll('.product-quantity__plus');
  const minusButtons = document.querySelectorAll('.product-quantity__minus');

  // Add event listeners for the plus buttons
  plusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const quantityInput = button.previousElementSibling; // The quantity input element
      let currentQuantity = parseInt(quantityInput.value); // Current quantity
      const productId = quantityInput.getAttribute('data-product-id'); // Product ID
      
      // Increase the quantity by 1
      currentQuantity++;
      quantityInput.value = currentQuantity;

      // Add to cart with the updated quantity
      addToCart(productId, currentQuantity);
    });
  });

  // Add event listeners for the minus buttons
  minusButtons.forEach(button => {
    button.addEventListener('click', function() {
      const quantityInput = button.nextElementSibling; // The quantity input element
      let currentQuantity = parseInt(quantityInput.value); // Current quantity
      const productId = quantityInput.getAttribute('data-product-id'); // Product ID

      // Decrease the quantity by 1 (but don't allow it to go below 1)
      if (currentQuantity > 1) {
        currentQuantity--;
        quantityInput.value = currentQuantity;
      }

      // Add to cart with the updated quantity
      addToCart(productId, currentQuantity);
    });
  });

  // Function to add product to the cart via AJAX
  function addToCart(productId, quantity) {
    const formData = {
      items: [{
        id: productId,
        quantity: quantity,
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then(response => response.json())
    .then(data => {
      // Success: Update cart information
      console.log('Product added to cart:', data);

      // Optionally update the cart count and total displayed on the page
      updateCartInfo(data);
    })
    .catch(error => {
      // Error handling
      console.error('Error adding product to cart:', error);
    });
  }

  // Function to update the cart count and total on the page
  function updateCartInfo(data) {
    const cartCount = document.querySelector('[data-cart-count]');
    const cartTotal = document.querySelector('[data-cart-total]');

    if (cartCount && cartTotal) {
      // Update the cart count and total with Shopify's liquid formatting
      cartCount.textContent = data.item_count;
      cartTotal.textContent = data.total_price; // No need to format money here, Shopify will do that in Liquid
    }
  }
});
